const unitelement = [
    { value: '次', label: '次' },
    { value: '部位', label: '部位' },
    { value: '穴位', label: '穴位' },
    { value: '单耳', label: '单耳' },
];

export default unitelement;